import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import Drawer from '@mui/material/Drawer';
import LaunchIcon from '@mui/icons-material/Launch';
import RichTable from '../components/richTable/RichTable.jsx'
import AlgoDrawer from '../algos/AlgoDrawer.js'
import tableHelpers from '../helpers/TableHelpers.js'
import Tooltip from '../components/Tooltip.js'
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import StockQuickLookDrawer from '../stock/StockQuickLookDrawer.js'

function PlanInfoDrawer(props) {

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [allocations, setAllocations] = useState([]);
    const [activeTrades, setActiveTrades] = useState([]);
    const [previewTrades, setPreviewTrades] = useState([]);
    const [showPreview, setShowPreview] = useState(false);

    useEffect(() => {
        (async function () {
            console.log('load plan info for plan id', props.planId);

            let allocationsText = await (await fetch(`/api/algos?planId=` + props.planId + `&years=5`)).json();
            console.log("allocations", allocationsText);
            setAllocations(allocationsText);

            let tradesText = await (await fetch(`/api/activeTrades?planId=` + props.planId)).json();
            console.log("activeTrades", tradesText);
            setActiveTrades(tradesText)

        })();
    }, [props.planId]);

    function algoSymbolLinkFormatter(cell, row) {
        let algoid = row.algoId;
        let symbol = row.trade_symbol;;
        let trade = activeTrades.find(t => t.algoId === row.idalgos);
        return (
            <div className='sameline'>
                {trade ? "🚨" : null}
                <StockQuickLookDrawer symbol={symbol} planId={props.planId} userId={props.userId} accountId={props.accountId} />
                &nbsp;<AlgoDrawer link={cell} planId={props.planId} accountId={props.accountId} userId={props.userId} mobileView={props.mobileView} algoId={algoid} role={props.role} />
            </div>
        )
    }

    async function runSneakPeek() {
        setShowPreview(true);
        setPreviewTrades([]);
        const url = `/api/strategyAlertTradePreview?returnAll=true&planId=` + props.planId;
        const trades = await (await fetch(url)).json();
        console.log("preview trades", trades);
        setPreviewTrades(trades);
    }

    function previewFormatter(cell, row) {
        let trade = previewTrades.find(t => t.algoId === cell);
        if (trade) {
            return (
                <Tooltip text={trade.action + " 🔍"} json={trade.currentBarData} position={"center top"} />
            );
        } else {
            return "Checking...";
        }
    }

    function closeDrawer() {
        console.log("Closing drawer");
        setDrawerOpen(false);
        setShowPreview(false);
        setPreviewTrades([]);
    }

    return (
        <div>
            <Link className="drawer-link" onClick={() => setDrawerOpen(true)}>{props.symbol} <LaunchIcon fontSize='small' /></Link>
            <Drawer
                anchor={'left'}
                open={drawerOpen}
                onClose={() => closeDrawer()}
            >
                <div style={{ padding: '20px' }}>
                    <center><b><Link onClick={() => closeDrawer()}>CLOSE</Link></b></center>
                    <br></br>
                    <center>
                        <Link onClick={() => runSneakPeek(true)}>Run Sneak Peek</Link>&nbsp;<QueryStatsIcon onClick={() => runSneakPeek(true)} />
                    </center>

                    <h4>Plan Allocations</h4>
                    <RichTable width="300" data={allocations} className="table-striped table-hover table-condensed" mappers={[
                        { title: 'Alloc', field: 'percentage', formatter: tableHelpers.percentFormatterNoDecimals, sorters: true },
                        { title: 'Algo', field: 'display_name', formatter: algoSymbolLinkFormatter, sorters: true },
                        { title: 'Type', field: 'algo_type', filter: 'choice', sorters: true },
                        { title: 'Preview', field: 'algoId', formatter: previewFormatter, sorters: true, hidden: !showPreview },
                    ]} />

                    <br></br>
                    <center><b><Link onClick={() => closeDrawer()}>CLOSE</Link></b></center>
                </div>
            </Drawer>
        </div >
    );
}

export default PlanInfoDrawer;